import createTableStore from "ds/components/Table/store/useTableStore";

import { PERSONAL_SETTINGS_SPACES_TABLE_STORAGE_KEY, TABLE_COLUMNS } from "../constants";

const usePersonalSettingsSpacesTableStore = createTableStore({
  storageKey: PERSONAL_SETTINGS_SPACES_TABLE_STORAGE_KEY,
  config: TABLE_COLUMNS,
});

export default usePersonalSettingsSpacesTableStore;
